import { render, staticRenderFns } from "./ref-register.pug?vue&type=template&id=0cc075c6&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./ref-register.scss?vue&type=style&index=0&id=0cc075c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc075c6",
  null
  
)

export default component.exports